import React from 'react';
import Overview from '../components/projects/Overview.component';
import Summary from '../components/projects/Summary.component';
import Files from '../components/projects/Files.component';
import Tags from '../components/Tag/Tags.component';
import Analysis from '../components/projects/Analysis.component';
import ProtectedRoute from './protected.routes'
import Output from '../components/projects/output/Output.component';


export default <React.Fragment>
  <ProtectedRoute exact path='/' component={Overview} />
  <ProtectedRoute exact path='/:id/summary' component={Summary} />
  <ProtectedRoute exact path='/:id/files' component={Files} />
  <ProtectedRoute exact path='/:id/tag' component={Tags} />
  <ProtectedRoute exact path='/:id/analysis' component={Analysis} />
  <ProtectedRoute exact path='/:id/output' component={Output} />
</React.Fragment>

